import _ from 'lodash';
import { Component, OnInit, Inject } from '@angular/core';
import { Location } from '@angular/common';
import { QuotationService } from '../../../../services/index';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { Util } from '../../../../utils/index';
declare var $:any;
declare var require: any;

@Component({
	selector: 'container-fare-all',
  templateUrl: 'fare-all.html',
})
export class FareallComponent implements OnInit {
  cnsltnQuotLst: Array<any> = [];
  cnsltnReq = {
    transTp: 0,
  };
  crncyRateLst: Array<any> = [];
  cargoLst: Array<any> = [];

  crncy: string;
  crncyValue: number = 0;

  currencyFormat:Function = Util.currencyFormat;
  dateFomatter2:Function = Util.dateFomatter2;

  showDep: boolean = false;
  showTrans: boolean = false;
  showArr: boolean = false;

  depHeight: number = 42;
  transHeight: number = 42;
  arrHeight: number = 42;

  tabIndex:number = 0;

  constructor(
    private location:Location,
    private route: ActivatedRoute,
    private quotationService: QuotationService,
  ) {}
	
	ngOnInit(): void {
    this.route.paramMap
      .switchMap((params: ParamMap) => this.quotationService.getConsultReport(params.get('id')))
      .subscribe(
			  resp => {
          this.getConsultQuotLst(resp.data);
			  },
			  error => {console.log(error)},
        () => console.log('done')
      );

  }

  getConsultQuotLst(consult) {
    this.cnsltnQuotLst = consult.cnsltnQuotLst;
    this.cnsltnReq = consult.cnsltnReq;
    this.crncyRateLst = consult.crncyRateLst;
    this.cargoLst = consult.cnsltnReq.crgoLst;

    this.getCstLst(this.cnsltnQuotLst, this.crncyRateLst);
  }

  getCstLst(quot, crncyRateLst) {
    var ttCost = [];
    var ttCrncy = [];
    this.crncy = crncyRateLst[0].crncyCd;
    

    for (var i=0 ; i < quot.length; i++) {
      let quotRouteListBySeq = [];
      for(var j=0; j<quot[i].quotRouteList.length; j++) {
        let indexRoute = _.find(quot[i].quotRouteList, {'seq' : j});
        quotRouteListBySeq.push(indexRoute);
      }

      quot[i].quotRouteListBySeq = quotRouteListBySeq;
      
      this.getRouteType(quot[i].quotRouteListBySeq);

      // quot[i].optNum = 'Forwarder ' +  String.fromCharCode(65 + i);
      quot[i].totalCrncy = '';
      quot[i].totalCost = '';
      var depCosts = [];
      var transCosts = [];
      var arrCosts = [];
      quot[i].depCost;
      quot[i].depCrncy;
      quot[i].transCost;
      
       //Total
       if(quot[i].totalCrncyCd){
        let crncyIdx = (quot[i].summary && quot[i].summary.crncyIndexMap) ? quot[i].summary.crncyIndexMap[quot[i].totalCrncyCd] : null;
        quot[i].totalCrncy = quot[i].totalCrncyCd;
        quot[i].totalCost = (crncyIdx !== null) ? quot[i].summary.totalCost[crncyIdx] : 0;
      }else{
        for (var k=0; k < quot[i].summary.totalCost.length; k++) {
          if(this.crncyValue == k) {
            quot[i].totalCrncy = this.crncy; 
            quot[i].totalCost = quot[i].summary.totalCost[k];
          }
        }
      }
      //total 코스트 출력
      
      //출발지 코스트
      if(quot[i].orgCrncyCd) {
        let depCrncyIdx = (quot[i].summary && quot[i].summary.crncyIndexMap) ? quot[i].summary.crncyIndexMap[quot[i].orgCrncyCd] : null;
        let depCosts = (quot[i].summary && quot[i].summary.sumCostList) ? _.find(quot[i].summary.sumCostList, { cstTp : 0 }) : null;
        if(depCrncyIdx != null && depCosts != null) quot[i].depCost = depCosts.sumCost[depCrncyIdx];
        else quot[i].depCost = 0;
      } else {
        for (var k=0; k < quot[i].summary.totalCost.length; k++) {
          if(this.crncyValue == k) {
            quot[i].orgCrncyCd = this.crncy; 
            let depCosts = _.find(quot[i].summary.sumCostList, { cstTp : 0 });
            if(depCosts != null) quot[i].depCost = depCosts.sumCost[k];
            else  quot[i].depCost = 0;
          }
        }
      }
      
      //도착지 코스트
      if(quot[i].desCrncyCd) {
        let arrCrncyIdx = (quot[i].summary && quot[i].summary.crncyIndexMap) ? quot[i].summary.crncyIndexMap[quot[i].desCrncyCd] : null;
        let arrCosts = (quot[i].summary && quot[i].summary.sumCostList) ? _.find(quot[i].summary.sumCostList, { cstTp : 1 }) : null;
        if(arrCrncyIdx != null && arrCosts != null) quot[i].arrCost = arrCosts.sumCost[arrCrncyIdx];
        else quot[i].arrCost = 0;
      } else {
        for (var k=0; k < quot[i].summary.totalCost.length; k++) {
          if(this.crncyValue == k) {
            quot[i].desCrncyCd = this.crncy; 
            let arrCosts = _.find(quot[i].summary.sumCostList, { cstTp : 1 });
            if(arrCosts != null) quot[i].arrCost = arrCosts.sumCost[k];
            else quot[i].arrCost = 0;
          }
        }
      }

      //운송 운임
      if(quot[i].transCrncyCd) {
        let transCrncyIdx = (quot[i].summary && quot[i].summary.crncyIndexMap) ? quot[i].summary.crncyIndexMap[quot[i].transCrncyCd] : null;
        let transCosts = null;
        if(quot[i].summary && quot[i].summary.sumCostList) {
          transCosts = _.find(quot[i].summary.sumCostList, { cstTp : 2 });
          if(transCosts == null) transCosts = _.find(quot[i].summary.sumCostList, { cstTp : 3 });
        }
      
        if(transCrncyIdx != null && transCosts != null) quot[i].transCost = transCosts.sumCost[transCrncyIdx];
        else quot[i].transCost = 0;
      } else {
        for (var k=0; k < quot[i].summary.totalCost.length; k++) {
          if(this.crncyValue == k) {
            quot[i].transCrncyCd = this.crncy; 
            let transCosts = null;
            if(quot[i].summary && quot[i].summary.sumCostList) {
              transCosts = _.find(quot[i].summary.sumCostList, { cstTp : 2 });
              if(transCosts == null) transCosts = _.find(quot[i].summary.sumCostList, { cstTp : 3 });
            }
            
            if(transCosts != null) quot[i].transCost = transCosts.sumCost[k];
            else quot[i].transCost = 0;
          }
        }
      }

      quot[i].transTp = this.getTransTp();
      quot[i].depCosts = this.costList(quot[i].cstLst, 0);
      quot[i].arrCosts = this.costList(quot[i].cstLst, 1);
      
      quot[i].transCosts = this.costList(quot[i].cstLst, 2);
      if(_.isEmpty(quot[i].transCosts)) quot[i].transCosts = this.costList(quot[i].cstLst, 3);
    }
  }

  getRouteType(quotRoutes) {
    let polIndex = -1;
		let podIndex = -1;
    
    for (var i=0; i<quotRoutes.length; i++) {
      var route = quotRoutes[i];
      route.transType = '';
      
      if(i < quotRoutes.length) {
        switch (route.typeCdNm) {  
          case 'PORT':
            route.transType = 'vessel';
            break;

          case 'AIRPORT':
            route.transType = 'air';
            if(route.location && route.location.name) {
              let depstr = _.clone(route.location.name);
              depstr = depstr.replace(/international/i, "Int'l");
              depstr = depstr.replace(/airport/i, 'Apt.');
              route.location.name = depstr;
            }
            break;

          case 'DOOR':
            route.transType = 'truck';
            break;

          case 'RAIL':
            route.transType = 'rail';
            break;

          default:
            route.transType = 'vessel';
        }
      }
      
      if(this.cnsltnReq.transTp == 1 && route.typeCd == NodeType.PORT){
				i = 0;
				continue;
			}

			if(this.cnsltnReq.transTp == 0 && route.typeCd == NodeType.AIRPORT){
				i = 0;
				continue;
			}

			if(polIndex == -1 && (route.typeCd == NodeType.PORT || route.typeCd == NodeType.AIRPORT)){
				polIndex = i;
			}
			if(polIndex > -1 && (route.typeCd == NodeType.PORT || route.typeCd == NodeType.AIRPORT)){
				podIndex = i;
			}
			if(route.typeNm == 'POL' || route.typeNm == 'POD'){
				if(route.typeCd == NodeType.AIRPORT){
					route.typeNm = 'AIR PORT';
				}else{
					route.typeNm = 'PORT';
				}
      }
    }

    if(polIndex > -1){
			quotRoutes[polIndex].typeNm = 'POL';
		}
		if(podIndex > -1){
      quotRoutes[podIndex].typeNm = 'POD';
      quotRoutes[podIndex].transType = 'truck';
      quotRoutes[podIndex].linerCd = null;
      quotRoutes[podIndex].linerNm = null;
    }
  }

  polPodFind(quot, polpod) {
    let route = _.find(quot.quotRouteListBySeq, {typeNm : polpod});
    
    if(route && route.location) {
      let location = route.location;
      if(this.cnsltnQuotLst.length > 5) {
        return '[' + location.locationCd + ']';
      } else {
        return '[' + location.locationCd + '] ' + location.name;
      }
    } else {
      return polpod;
    }
    
  }


  getSum(total, num) {
    return total + num;
  }

  getTransTp() {
    if(this.cnsltnReq.transTp == 0) {
      return '해상운송';
    } else {
      return '항공운송';
    }
  }

  costList(cstLst, num) {
    let cst = [];
    if(cstLst) {
      for(let i=0; i<cstLst.length; i++) {
        if(num === cstLst[i].cstTp) {
          cst.push(cstLst[i]);
        }
      }
    }

    return cst;
  }

  showCosts(event, showTp) {
    var quot = this.cnsltnQuotLst;
    var minHeight = 42;
    
    if(showTp == 0) {
      var leng: Array<number> = [];
      if(this.showDep) {
        this.showDep = false;
        this.depHeight = minHeight;
      } else {
        this.showDep = true;
        for(let i = 0; i<quot.length; i++) {
          leng.push(quot[i].depCosts.length);
        }
        var biggest = Math.max(...leng);
        this.depHeight = minHeight * biggest + minHeight;
      }

    } if(showTp == 1) {
      var leng: Array<number> = [];
      if(this.showTrans) {
        this.showTrans = false;
        this.transHeight = minHeight;
      } else {
        this.showTrans = true;
        for(let i = 0; i<quot.length; i++) {
          leng.push(quot[i].transCosts.length);
        }
        var biggest = Math.max(...leng);
        this.transHeight = minHeight * biggest + minHeight;
      }
    } else if(showTp == 2) {
      var leng: Array<number> = [];
      if(this.showArr) {
        this.showArr = false;
        this.arrHeight = minHeight;
      } else {
        this.showArr = true;
        for(let i = 0; i<quot.length; i++) {
          leng.push(quot[i].arrCosts.length);
        }
        var biggest = Math.max(...leng);
        this.arrHeight = minHeight * biggest + minHeight;
      }
    } else {
      return null;
    }
  }

  longToShort(item: string) {
    if(_.values(item).length > 30) {
      item = item.substring(0,30)+"...";
    }
    return item;
  }

  download() {
    
    var divHeight = $('#fare-all').height();
    var divWidth = $('#fare-all').width();
    var ratio = divHeight / divWidth;

    const jsPDF = require('../../../../../../node_modules/jspdf');
    const html2canvas = require('../../../../../../node_modules/html2canvas');

    html2canvas(document.getElementById('fare-all'), {
      height: divHeight,
      width: divWidth,

      onrendered: function(canvas) {
        var imgData = canvas.toDataURL('image/png');
        var doc = new jsPDF('p', 'mm', [297, 210]);
        
        var width = doc.internal.pageSize.width;    
        var height = doc.internal.pageSize.height;

        height = ratio * width;

        doc.addImage(imgData, 'PNG', 10, 10, width-20, height-10);    
        doc.save('Tradlinx.pdf');
      }
    })
  }


  goBack() {
    this.location.back();
  }
}

export enum NodeType {
  ORIGIN = 0, POL, TSPORT, POD, DESTINATION, NODE, RAIL, DOOR, PORT, AIRPORT
}



// WEBPACK FOOTER //
// ./src/app/containers/quotation/forwarder/fare-all/fare-all.ts